var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskyResource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5350_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8125 5.87691V3.27871C0.8125 3.09511 0.999839 2.89062 1.12473 2.89062H13.9172C14.1252 2.89062 14.3125 3.09511 14.3125 3.27871V5.69331C13.6056 5.75472 12.9606 5.95921 12.378 6.26562H1.12473C0.999839 6.26562 0.8125 6.06114 0.8125 5.87691ZM1.9375 5.14062H3.0625V4.01562H1.9375V5.14062ZM3.625 5.14062H4.75V4.01562H3.625V5.14062Z",
    fill: "#6B696A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8125 10.94V8.34184C0.8125 8.15761 0.999839 7.95312 1.12473 7.95312H13.9172C14.1252 7.95312 14.3125 8.15761 14.3125 8.34184V10.7558C13.6056 10.8172 12.9606 11.0217 12.378 11.3281H1.12473C0.999839 11.3281 0.8125 11.1236 0.8125 10.94ZM1.9375 10.2031H3.0625V9.07812H1.9375V10.2031ZM3.625 10.2031H4.75V9.07812H3.625V10.2031Z",
    fill: "#6B696A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8125 13.4043C0.8125 13.2201 0.999839 13.0156 1.12473 13.0156H13.9172C14.1252 13.0156 14.3125 13.2201 14.3125 13.4043V15.8183C14.3125 16.1811 14.2179 16.3906 13.5025 16.3906H1.12473C0.999839 16.3906 0.8125 16.1868 0.8125 16.0025V13.4043ZM1.9375 15.2656H3.0625V14.1406H1.9375V15.2656ZM3.625 15.2656H4.75V14.1406H3.625V15.2656Z",
    fill: "#6B696A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6782 7.2673C18.6782 10.2181 16.2858 12.6108 13.3346 12.6108C10.3834 12.6108 7.99109 10.2181 7.99109 7.2673C7.99109 4.3161 10.3834 1.92334 13.3346 1.92334C16.2858 1.92334 18.6782 4.3161 18.6782 7.2673Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8031 6.82835C19.8031 9.93444 17.2849 12.4531 14.1784 12.4531C11.0718 12.4531 8.55359 9.93444 8.55359 6.82835C8.55359 3.72182 11.0718 1.20312 14.1784 1.20312C17.2849 1.20312 19.8031 3.72182 19.8031 6.82835Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 2.57666C19.2271 3.63135 19.7617 4.91309 19.7617 6.42188C19.7617 7.93066 19.2271 9.21973 18.1577 10.2891C17.103 11.3438 15.8213 11.8711 14.3125 11.8711C12.8037 11.8711 11.5146 11.3438 10.4453 10.2891C9.39062 9.21973 8.86328 7.93066 8.86328 6.42188C8.86328 4.91309 9.39062 3.63135 10.4453 2.57666C11.5146 1.50732 12.8037 0.972656 14.3125 0.972656C15.8213 0.972656 17.103 1.50732 18.1577 2.57666ZM15.0156 7.82812C14.8252 7.62305 14.5908 7.52051 14.3125 7.52051C14.0342 7.52051 13.7925 7.62305 13.5874 7.82812C13.397 8.01855 13.3018 8.25293 13.3018 8.53125C13.3018 8.80957 13.397 9.05127 13.5874 9.25635C13.7925 9.44678 14.0342 9.54199 14.3125 9.54199C14.5908 9.54199 14.8252 9.44678 15.0156 9.25635C15.2207 9.05127 15.3232 8.80957 15.3232 8.53125C15.3232 8.25293 15.2207 8.01855 15.0156 7.82812ZM13.3457 3.89502L13.5215 6.8833C13.5215 7.04443 13.6094 7.125 13.7852 7.125H14.8398C15.0156 7.125 15.1035 7.04443 15.1035 6.8833L15.2793 3.89502C15.2793 3.80713 15.25 3.74121 15.1914 3.69727C15.1475 3.63867 15.0889 3.60938 15.0156 3.60938H13.6094C13.5361 3.60938 13.4702 3.63867 13.4116 3.69727C13.3677 3.74121 13.3457 3.80713 13.3457 3.89502Z",
    fill: "#368FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5350_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.125,
    height: 15.8111,
    fill: "white",
    transform: "translate(0.8125 0.640625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskyResource);
export default __webpack_public_path__ + "static/media/risky_resource.0a57eb95e701b2e947facb0ce008d78a.svg";
export { ForwardRef as ReactComponent };